import { AxiosInstance } from 'axios';
import { SingleUserType } from 'types/GlobalTypes';
import { IBaseService, BaseService } from './BaseServiceClass';
import { APIResponseHandler } from 'utilities/ErrorHelper';
import { IRevokeAccess } from 'stores/UsersStore';

export interface IUsersService extends IBaseService<SingleUserType> {
  addToOrganization(user: SingleUserType, orgId: string): Promise<any>;
  getAllUsers(orgid: string): Promise<any>;
  revokeUser(content: IRevokeAccess): Promise<any>;
  findNewUserByEmail(email: string): Promise<any>;
}

export class UsersService extends BaseService<SingleUserType> implements IUsersService {
  constructor(axiosInstance: AxiosInstance) {
    super(axiosInstance, 'api/users');
  }

  addToOrganization = async (user: SingleUserType, orgId: string): Promise<any> => {
    const response = await this._axiosInstance.post(`api/users/${user.id}/organization/${orgId}`, { Role: user.type });
    return APIResponseHandler(response);
  }

  getAllUsers = async (orgid: string): Promise<any> => {
    const response = await this._axiosInstance.get(`api/users/organization/${orgid}`);
    
    // Return the full response object for 404 so we can check status in the store
    if (response.status === 404) {
      return response;
    }

    return APIResponseHandler(response);
  };

  revokeUser = async (content: IRevokeAccess): Promise<any> => {
    const response = await this._axiosInstance.delete(`api/users/${content.userId}/organization/${content.organizationId}`);
    return APIResponseHandler(response);
  };

  findNewUserByEmail = async (email: string): Promise<any> => {
    const response = await this._axiosInstance.get(`api/users/email/${encodeURIComponent(email)}`);
    return APIResponseHandler(response);
  };
}